import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
    selector: 'topo-close',
    imports: [NgClass],
    template: `
    <div
      class="close"
      [ngClass]="size()"
      (click)="onClick.emit()">
      <i class="icon icon-close-X"></i>
    </div>
  `,
    styleUrl: './close.component.scss'
})
export class CloseComponent {
  size = input<'tiny' | 'small' | 'medium' | 'regular' | 'normal' | 'large' | 'extra-large'>('medium');
  onClick = output();
}
